import axios from "axios"
import { emitBreakLock } from "src/break/bus"

// Root of the API host. The SignalR hub lives at {apiRootURL}/hubs/break, next to the /api
// routes, so the host is exported separately from the REST base URL.
export const apiRootURL = 'https://api-crm.superfares.com';
export const airportApiURL = 'https://api.shipratravel.com/flightSearch/api/';
export const bookingAPIURL = 'https://api.shipratravel.com/flightbooking/api/';
const baseURL = `${apiRootURL}/api/`;
export const apiRequest = axios.create({
    baseURL: baseURL,
});

// Add a response interceptor
apiRequest.interceptors.response.use(
    response => {
        if (response.status === 401) {
            window.location.href = '/login';
        }
        return response
    },
    error => {
        const res = error.response;
        if (res && res.status === 401) {
            window.location.href = '/login';
            return Promise.reject(error);
        }
        // 423 is the break lock. It is not an auth failure, so it must never log the agent out,
        // and it must never reach the page as a normal API error - the global break overlay is
        // the message. The rejection is flagged so callers can skip their own error handling.
        if (res && res.status === 423 && res.data && res.data.Code === 'ON_BREAK') {
            emitBreakLock(res.data);
            const breakLockError = new Error(res.data.Message || 'You are on a break.');
            breakLockError.isBreakLock = true;
            breakLockError.breakSeconds = res.data.BreakSeconds || 0;
            breakLockError.response = res;
            return Promise.reject(breakLockError);
        }
        return Promise.reject(error);
    }
);
